/**
 * Shared display formatters for influencer-facing pages.
 */

/** 12500 -> "12.5K", 3400000 -> "3.4M". Safe on strings/null/NaN. */
export function formatCount(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  if (num >= 1000000) {
    const short = num / 1000000;
    return `${short % 1 === 0 ? short : short.toFixed(1)}M`;
  }
  if (num >= 10000) {
    const short = num / 1000;
    return `${short % 1 === 0 ? short : short.toFixed(1)}K`;
  }
  if (num % 1 !== 0) return num.toFixed(2);
  return String(num);
}

/** 150000 -> "₹1,50,000". Safe on strings/null/NaN. */
export function formatINR(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return '—';
  return `₹${num.toLocaleString('en-IN')}`;
}

/** ISO date -> "05 Aug 2026". Safe on null/invalid. */
export function formatDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

/** "some_status" -> "Some Status" */
export function titleCase(value) {
  if (!value) return '';
  return String(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\b[a-z]/g, (letter) => letter.toUpperCase());
}
